import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  step: {
    borderRadius: '10px',
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    padding: '1.5rem 1.75rem',
    position: 'relative',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.05)',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease',
    '&:hover': {
      boxShadow: '0 8px 28px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
      transform: 'translateY(-2px)'
    }
  },
  stepCompleted: {
    borderLeft: '4px solid #22c55e',
    backgroundColor: '#fafffe'
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.25rem'
  },
  badge: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #4c4cff 0%, #6366f1 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.125rem',
    fontWeight: 700,
    color: '#fff',
    flexShrink: 0,
    boxShadow: '0 2px 8px rgba(76, 76, 255, 0.3)'
  },
  badgeCompleted: {
    background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
    boxShadow: '0 2px 8px rgba(34, 197, 94, 0.3)'
  },
  body: {
    flex: 1,
    minWidth: 0
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.625rem',
    marginBottom: '0.375rem'
  },
  title: {
    fontWeight: 600,
    color: '#1a1a1a',
    fontSize: '1rem'
  },
  completedPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.25rem',
    fontSize: '0.6875rem',
    fontWeight: 600,
    color: '#065f46',
    backgroundColor: '#ecfdf5',
    padding: '0.125rem 0.5rem',
    borderRadius: '999px',
    letterSpacing: '0.3px',
    textTransform: 'uppercase'
  },
  description: {
    color: '#5c5e6e',
    lineHeight: 1.55,
    fontSize: '0.875rem'
  },
  button: {
    width: '220px',
    whiteSpace: 'nowrap',
    fontSize: '0.875rem',
    padding: '0.6rem 1.5rem',
    textAlign: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  connector: {
    width: '2px',
    height: '28px',
    marginLeft: '2.85rem',
    borderLeft: '2px dashed #c5cae9'
  },
  connectorCompleted: {
    borderLeft: '2px solid #22c55e'
  }
});

export default useStyles;
